module.exports = __webpack_public_path__ + "static/media/logo-app-store.953be89e.svg";